import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // V1: solo logueamos a consola. En el futuro, push a Application Insights.

    console.error('ErrorBoundary captured error', error, info);
  }

  handleRetry = (): void => {
    this.setState({ error: null });
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  render(): ReactNode {
    if (this.state.error) {
      return (
        <Box sx={{ p: 4, maxWidth: 720, mx: 'auto' }}>
          <Alert severity="error" sx={{ mb: 2 }}>
            <AlertTitle>Algo salió mal</AlertTitle>
            {this.state.error.message ?? 'Error inesperado en la aplicación.'}
          </Alert>
          <Button variant="contained" onClick={this.handleRetry}>
            Reintentar
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}
